import config from "../../../config";
import { SectionDetails } from "../../molecules/SectionDetails";
import { ProfileImage, ProfileDescriptionText } from "./style";

function About() {
  return (
    <SectionDetails
      heading={<ProfileImage />}
      details={<ProfileDescriptionText>{config.bio}</ProfileDescriptionText>}
    />
  );
}

export default About;
